import React from 'react';
import axios from "../../../containers/api";
import DatePicker from 'react-modern-calendar-datepicker';
import { Link } from "react-router-dom";
import Mapir from "mapir-react-component";
import polyline from "google-polyline";
import { convertDate, getkalas, getLoaderTypes, GetDistinctLoaderTypes, getBastebandys, showCatchError, toEnglishNumbers, toCurrency, convertDateToDatepicker, getDurationHour} from "../../../helpers/Utils";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import { Button, Card, CardBody, Collapse, Input, Row, Alert, InputGroupAddon, InputGroup, FormGroup, Label, CustomInput, ModalBody, Modal, ModalHeader, ModalFooter } from "reactstrap";
import Config from "../../../constants/config";
import "../../../assets/css/sass/maps.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AddCustomerModal from "../../info-base/customer/components/AddCustomerModal";
import EditCustomer from "../../info-base/customer/components/EditCustomer";
import Customer from "../../info-base/customer/Customer";
const Map = Mapir.setToken({
    transformRequest: url => {
        return {
            url: url,
            headers: {
                "x-api-key": Config.mapIrToken,
                "Mapir-SDK": "reactjs"
            }
        };
    }
});

class EditCargo extends React.Component {

    constructor(props) {
        super(props);
        this.mapContainer = React.createRef();
        this.origin = React.createRef();
        this.destination = React.createRef();

        this.state = {
             cargoId: this.props.match.params.cargoId,
            searchValue: "",
            sender: null,
            senderAddresses: [],
            senderAddress: null,
            receiver: null,
            receiverAddresses: [],
            receiverAddress: null,
            customer: [],

            cargoRange: 2000,
            kalaValue: 0,
            Tel: "",
            kala: null,
            Bastebandy: null,
            freighterNumber: 0,
            bastebandyNumber: 1,
            kalaWeight: 0,
            cargoRent: null,
            description: null,
            selectedLoaderTypes: [],
            map: null,
            cargoSource: "",
            cargoDestination: "",
            cargoDistance: "",
            cargoDuration: "",
            cargoSourceLat: "",
            cargoSourceLong: "",
            cargoDestinationLat: "",
            cargoDestinationLong: "",
            directionsService: null,
            directionsRenderer: null,
            searchBox1: null,
            searchBox2: null,
            geoCoder: null,
            errors: [], 
            errorInputs: [],
            OriginCities: [],
            geojson: null,

            iranmap: Config.IsMapIr,
            Bastebandys: [],
            kalas: [],
            loaderTypes: [],
            provinces: [],
            loadHall: null,
            LoadHallList: [],
            loading: false,
            loaderTypeCodes: [],
            selectedLoaderTypeCode: null,

        };
    }

    checkAndLoadCargo = () => {
        const { Bastebandys, loaderTypes, kalas,   loading } = this.state;
        if (Bastebandys.length && loaderTypes.length && kalas.length   && !loading) {
            this.setState({ loading: true }, () => this.GetCargoById());
        }
    };
    async componentDidMount() {

        this.GetCustomerByTransportationCompanyId();
        this.GetDistinctLoaderTypes();


        try {
            this.GetTransportationCompanyHallByTransportationCompanyId();

        }
        catch (err) {
            console.log(err);
        }

        try {
            await Promise.all([
                //this.GetAllCity(),
                this.getBastebandysApi(),
                this.getLoaderTypesApi(),
                this.getkalasApi()
            ]);

            this.checkAndLoadCargo();
        } catch (err) {
            console.error("خطا در گرفتن اطلاعات اولیه:", err);
        }
    }


    //componentDidMount() {

    //    this.GetCustomerByTransportationCompanyId();
    //    this.GetDistinctLoaderTypes();


    //    try {
    //        this.GetTransportationCompanyHallByTransportationCompanyId();

    //    }
    //    catch (err) {
    //        console.log(err);
    //    }
    //   // this.GetAllCity().then(this.checkAndLoadCargo);
    //    this.getBastebandysApi().then(this.checkAndLoadCargo);
    //    this.getLoaderTypesApi().then(this.checkAndLoadCargo);
    //    this.getkalasApi().then(this.checkAndLoadCargo);


    //}
     //checkPermission = () => {
     //    axios.get('api/ClientApi/HasAccessTo?permissionName=Load_Add')
     //        .then((res) => {
     //        if (res.data) {
                
     //            this.GetCustomerByTransportationCompanyId();

                 
     //            try {
     //                this.getBastebandysApi().then(r => {
     //                    if (this.state.Bastebandys.length !== 0 && this.state.loaderTypes.length !== 0 && this.state.customer.length !== 0 && !this.state.loading) {
     //                        this.setState({loading: true});
     //                        this.GetCargoById();
     //                    }
     //                });
     //            } catch (err) {
     //                console.log(err);
     //            }
     //            try {
     //                this.getLoaderTypesApi().then(r => {
     //                    if (this.state.Bastebandys.length !== 0 && this.state.loaderTypes.length !== 0 && this.state.customer.length !== 0 && !this.state.loading) {
     //                        this.setState({loading: true});
     //                        this.GetCargoById();
     //                    }
     //                });
     //            } catch (err) {
     //                console.log(err);
     //            }
     //            try {
     //                this.getkalasApi().then(r => {
     //                    if (this.state.Bastebandys.length !== 0 && this.state.loaderTypes.length !== 0 && this.state.customer.length !== 0 && !this.state.loading) {
     //                        this.setState({loading: true});
     //                        this.GetCargoById();
     //                    }
     //                });
     //            } catch (err) {
     //                console.log(err);
     //            }
     //        } else {
     //            this.props.history.push('/error404');
     //        }
     //    })
     //        .catch((error) => {
     //            this.props.hideSpinner();
     //            this.props.showAlert(showCatchError(error), "error");
     //    });
     //};

     
    GetTransportationCompanyHallByTransportationCompanyId = async () => {
        this.props.showSpinner();
        try {
            const res = await axios.get('/api/v1/transportation-company-halls/GetTransportationCompanyHallByTransportationCompanyId');
            this.props.hideSpinner();
            this.setState({ LoadHallList: res.data.data });
        } catch (error) {
            this.props.hideSpinner();
            this.props.showAlert(showCatchError(error), "error");
        }
    };
    GetCustomerByTransportationCompanyId = async () => {
        try {
            const res = await axios.get('/api/v1/customers/GetCustomerByTransportationCompanyId');
            this.props.hideSpinner();
            this.setState({ customer: res.data.data });
        } catch (error) {
            this.props.hideSpinner();
            this.props.showAlert(showCatchError(error), "error");
        }
    };
  
     async getBastebandysApi() {
         try {
             await getBastebandys()
                 .then((res) => this.setState({Bastebandys: res.data}));
         } catch (err) {
             this.props.showAlert(showCatchError(err), "error");
         }
     }
     async getLoaderTypesApi() {
         try {
             await getLoaderTypes()
                 .then((res) => this.setState({loaderTypes: res.data}));
         } catch (err) {
             this.props.showAlert(showCatchError(err), "error");
         }
     }
     async getkalasApi() {
         try {
             await getkalas()
                 .then((res) => this.setState({kalas: res.data}));
         } catch (err) {
             this.props.showAlert(showCatchError(err), "error");
         }
     }
    //async GetDistinctLoaderTypes() {
    //    try {
    //        await GetDistinctLoaderTypes()
    //            .then((res) => {
    //                this.setState({ loaderTypeCodes: res.data });
    //                //console.log("GetDistinctLoaderTypes");
    //                //console.log(res.data);
    //            })

    //    } catch (err) {
    //        this.props.showAlert(showCatchError(err), "error");
    //    }
    //}
    async GetDistinctLoaderTypes() {
        try {
            const res = await GetDistinctLoaderTypes(); // صبر میکنه تا Promise تموم بشه
            this.setState({ loaderTypeCodes: res.data });
            // console.log(res.data);
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    getLoaderTypesByCode = (Code) => {
        axios.get('/api/v1/loader-types/GetLoaderTypeByCode?Code=' + Code)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ loaderTypes: res.data.data });
                //console.log("getLoaderTypesByCode");
                //console.log( res.data) ;
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
     setOrigin = () => {
         let place1 = this.state.searchBox1.getPlaces()[0];
         if (place1.hasOwnProperty("geometry")) {
             this.setState({ cargoSource: place1.name});
             this.setState({cargoSourceLat: place1.geometry.location.lat()});
             this.setState({cargoSourceLong: place1.geometry.location.lng()}, () => this.routing());
             this.state.map.fitBounds(place1.geometry.viewport);
             new window.google.maps.Marker({
                 position: {lat: this.state.cargoSourceLat, lng: this.state.cargoSourceLong},
                 map: this.state.map,
                 title: "مبدا"
             });
         } else {
             this.props.showAlert('مکان انتخاب شده صحیح نیست! لطفا هنگام جستجو از روی لیست پیشنهادی بر روی گزینه مورد نظر خود کلیک کنید', "error");
         }
     };
     setDestination = () => {
         let place2 = this.state.searchBox2.getPlaces()[0];
         if (place2.hasOwnProperty("geometry")) {
             this.setState({ cargoDestination: place2.name});
             this.state.map.fitBounds(place2.geometry.viewport);
             this.setState({cargoDestinationLat: place2.geometry.location.lat()});
             this.setState({cargoDestinationLong: place2.geometry.location.lng()}, () => this.routing());
             new window.google.maps.Marker({
                 position: {lat: this.state.cargoDestinationLat, lng: this.state.cargoDestinationLong},
                 map: this.state.map,
                 title: "مقصد"
             });
         } else {
             this.props.showAlert('مکان انتخاب شده صحیح نیست! لطفا هنگام جستجو از روی لیست پیشنهادی بر روی گزینه مورد نظر خود کلیک کنید', "error");
         }
     };
     getOriginGeocode = () => {
         
             this.getCityOrigin();
         
     };
     getDestinationGeocode = () => {
         
             this.getCityDestination();
         
     };
     routing = () => {
         if (this.state.cargoSourceLat && this.state.cargoSourceLong && this.state.cargoDestinationLat && this.state.cargoDestinationLong) {
             
                 let duration = this.state.cargoSourceLong + "," + this.state.cargoSourceLat + ";" + this.state.cargoDestinationLong + "," + this.state.cargoDestinationLat;
                 fetch(
                     "https://map.ir/eta/driving/" + duration,
                     {
                         method: "GET",
                         headers: {
                             "Content-Type": "application/json",
                             "x-api-key": Config.mapIrToken,
                         }
                     }
                 )
                     .then(res => res.json())
                     .then(result => {
                         let dd = getDurationHour(result.routes.distance, result.routes.duration);
                         this.setState({cargoDuration: dd.hour});
                         this.setState({cargoDistance: dd.kilometer });
                     });
             
         }
     };
     getCityOrigin = () => {
         this.setState({OriginCities: []});

         let data = JSON.stringify({ "text": this.state.cargoSource, "$select": "city"});
         const requestOptions = {
             method: 'POST',
             headers: {
                 'Content-Type': 'application/json',
                 "x-api-key": Config.xApiKey
             },
             body: data
         };

         this.props.showSpinner();
         fetch('https://map.ir/search/v2/autocomplete', requestOptions)
             .then(response => response.json())
             .then((data) => {
                 this.props.hideSpinner();
                 if (data.value !== undefined) {
                     this.setState({OriginCities: data.value[0]})
                     this.setState({cargoSourceLat: data.value[0].geom.coordinates[1]});
                     this.setState({cargoSourceLong: data.value[0].geom.coordinates[0]},
                         () => this.routing());
                 } else {
                     this.setState({OriginCities: []});
                 }
             })
             .catch((error) => {
                 this.props.hideSpinner();
                 console.log(error.response);
                 this.props.showAlert(showCatchError(error), "error");
             });
     };
     getCityDestination = () => {
         this.setState({OriginCities: []});

         let data = JSON.stringify({ "text": this.state.cargoDestination, "$select": "city"});
         const requestOptions = {
             method: 'POST',
             headers: {
                 'Content-Type': 'application/json',
                 "x-api-key": Config.xApiKey
             },
             body: data
         };

         this.props.showSpinner();
         fetch('https://map.ir/search/v2/autocomplete', requestOptions)
             .then(response => response.json())
             .then((data) => {
                 this.props.hideSpinner();
                 if (data.value !== undefined) {
                     this.setState({OriginCities: data.value[0]});
                     this.setState({cargoDestinationLat: data.value[0].geom.coordinates[1]});
                     this.setState({cargoDestinationLong: data.value[0].geom.coordinates[0]},
                         () => this.routing());
                     this.setState({geojson: {}});
                     this.getDriverLocations(data.value[0].geom.coordinates[0], data.value[0].geom.coordinates[1]);
                 } else {
                     this.setState({OriginCities: []});
                 }
             })
             .catch((error) => {
                 this.props.hideSpinner();
                 console.log(error.response);
                 this.props.showAlert(showCatchError(error), "error");
             });
     };
     getDriverLocations = (longB, latB) => {
         let lnglon = this.state.cargoSourceLong + "," + this.state.cargoSourceLat + ";" + longB + "," + latB;

         fetch("https://map.ir/routes/route/v1/driving/" + lnglon + "?overview=full",
             {
                 method: "GET",
                 headers: {
                     "Content-Type": "application/json",
                     "x-api-key": Config.mapIrToken,
                 }
             })
             .then(res => res.json())
             .then(result => {
                 var decodeResult = polyline.decode(result.routes[0].geometry);
                 var reverseLatLon = decodeResult.map(items => items.reverse());
                 var geojsonpoint = {
                     type: "FeatureCollection",
                     features: [
                         {
                             type: "Feature",
                             properties: {},
                             geometry: {
                                 type: "LineString",
                                 coordinates: reverseLatLon
                             }
                         }
                     ]
                 };
                 this.setState({geojson: geojsonpoint});
             });
     };

    GetCargoById = () => {
        console.log(this.state.loaderTypeCodes)
        this.props.showSpinner();
         axios.get('/api/v1/cargos/GetCargoById/' + toEnglishNumbers(this.state.cargoId))
             .then((res) => {
                 this.props.hideSpinner();
                 this.setState({
                   
                   
                     freighterNumber: res.data.data.freighterNumber, 
                     kalaValue: res.data.data.kalaValue, 
                     Tel: res.data.data.tel, 
                     kalaWeight: res.data.data.kalaWeight, 
                     description: res.data.data.description,
                     cargoSourceLat: res.data.data.cargoSourceLat,
                     cargoSourceLong: res.data.data.cargoSourceLong,
                     cargoDestinationLat: res.data.data.cargoDestinationLat,
                     cargoDestinationLong: res.data.data.cargoDestinationLong,
                     cargoDuration: res.data.data.cargoDuration,
                     cargoDistance: res.data.data.cargoDistance,
                     cargoRange: res.data.data.cargoRange,
                     cargoRent: res.data.data.cargoRent,
                     bastebandyNumber: res.data.data.bastebandyNumber,


                     selectedLoaderTypes: res.data.data.loaderTypes,
                   
                     
                   
                    
                     cargoSource: res.data.data.cargoSource,
                     cargoDestination: res.data.data.cargoDestination,
                     UniqueCode: res.data.data.uniqueCode,
                     iSG: res.data.data.isg,
                     shippingOrder: res.data.data.shippingOrder,
                 });

                 this.state.loaderTypeCodes && this.state.loaderTypeCodes.map((v) => {
                     if (v.typeCode === res.data.data.typeCode) {
                         this.setState({ selectedLoaderTypeCode: v });
                     }
                 });

                 this.state.kalas && this.state.kalas.map((v) => {
                     if (v.id === res.data.data.kalaId) {
                         this.setState({kala: v});
                     }
                 });
                 this.state.Bastebandys && this.state.Bastebandys.map((v) => {
                     if (v.id === res.data.data.bastebandyId) {
                         this.setState({Bastebandy: v});
                     }
                 });
                 this.state.LoadHallList && this.state.LoadHallList.map((v) => {
                    if (v.id === res.data.data.transportationCompanyHallId) {
                        this.setState({loadHall: v});
                        console.log(v);
                    }
                });
                console.log(this.state.LoadHallList);
                
                 //this.state.loaderTypes && this.state.loaderTypes.map((v) => {
                 //    if (v.value === res.data.data.loadType) {
                 //        this.setState({LoadType: v});
                 //    }
                 //});
                 
                 
                 
                 

                 //if (res.data.data.customerAddress === null) {
                 //    this.setState({AddLoadType: 1},
                 //        () => {
                 //            this.setState({
                 //                mapSourceInput: res.data.data.cargoSource,
                 //                mapDestinationInput: res.data.data.cargoDestination
                 //            })
                 //        });
                 //} else
                 if (res.data.data.senderCustomerId && res.data.data.receiverCustomerId) { 
                             
                             if (this.state.customer != null) {
                               
                                 this.state.customer.map((Customer) => {
                                     if (Customer.id === res.data.data.senderCustomerId) {
                                         this.setState({ sender: Customer},
                                             () => this.loadSenderAddresses(res.data.data.senderCustomerId, res.data.data.senderCustomerAddressId));
                                     }
                                     if (Customer.id === res.data.data.receiverCustomerId) {
                                         this.setState({receiver: Customer},
                                             () => this.loadReceiverAddresses(res.data.data.receiverCustomerId, res.data.data.receiverCustomerAddressId));
                                     }
                                 });
                             }
                        
                 }
             })
             .catch((error) => {
                 this.props.hideSpinner();
                 this.props.showAlert(showCatchError(error), "error");
                 console.log(error.response);
             });
     };
    closeModal = (modalName) => {
        if (modalName === "addCustomerModal" || modalName === "manageCustomerModal" || modalName === "editCustomerModal" || modalName === "manageCustomerModal") {
            this.GetCustomerByTransportationCompanyId();
        }
        this.setState({ [modalName]: false });
    };
    OptionsMenuClick = (event, id) => {
        this.setState({ [id]: event.currentTarget });
    };
    OptionsMenuClose = (id) => {
        this.setState({ [id]: null });
    };
    openCustomerModal = (modalName, id) => {
        //if (modalName === "addCustomerModal" || modalName === "manageCustomerModal") {
        //    if (this.state.provinces.length === 0) {
        //        this.loadProvinces();
        //    }
        //}

        if (modalName === "editCustomerModal" || modalName === "manageCustomerModal") {
            if (id === "receiverOptionsMenu") {
                this.state.currentCustomer = this.state.receiver;
            } else if (id === "senderOptionsMenu") {
                this.state.currentCustomer = this.state.sender;
            }
        }

        this.setState({
            [modalName]: true,
            [id]: null
        });
    }
    loadSenderAddresses = (selectedId, SenderAddressId) => {
        if (selectedId) {
            axios.get('/api/v1/customer-addresses/GetCustomerAddressByCustomerId?CustomerId=' + selectedId)
                .then((res) => {
                    if (res.data.data != null && res.data.data.length > 0) {
                        if (SenderAddressId != null) {
                            this.setState({ senderAddresses: res.data.data },
                                () => res.data.data.map((v) => {
                                    if (v.id === SenderAddressId) {
                                        this.setState({ senderAddress: v },
                                            () => this.setState({ Origin: this.state.senderAddress.cityName },
                                                () => this.getOriginGeocode()))
                                    }
                                    return null
                                }));
                        } else {
                            this.setState({ senderAddresses: res.data.data },
                                () => this.setState({ senderAddress: this.state.senderAddresses[0] },
                                    () => this.setState({ cargoSource: this.state.senderAddress.cityName },
                                        () => this.getOriginGeocode()))
                            );
                        }
                    } else {
                        this.setState({
                            senderAddresses: [],
                            senderAddress: null,
                            cargoSourceLat: null,
                            cargoSourceLong: null,
                            cargoSource: ""
                        })
                    }
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };
    loadReceiverAddresses = (selectedId, ReceiverAddressId) => {
        if (selectedId) {
            axios.get('/api/v1/customer-addresses/GetCustomerAddressByCustomerId?CustomerId=' + selectedId)
                .then((res) => {
                    if (res.data != null && res.data.data.length > 0) {
                        if (ReceiverAddressId != null) {
                            this.setState({ receiverAddresses: res.data.data },
                                () => res.data.data.map((v) => {
                                    if (v.id === ReceiverAddressId) {
                                        this.setState({ receiverAddress: v },
                                            () => this.setState({ Destination: this.state.receiverAddress.cityName },
                                                () => this.getDestinationGeocode()))
                                    }
                                    return null
                                }));
                        } else {
                            this.setState({ receiverAddresses: res.data.data },
                                () => this.setState({ receiverAddress: this.state.receiverAddresses[0] },
                                    () => this.setState({ cargoDestination: this.state.receiverAddress.cityName },
                                        () => this.getDestinationGeocode()))
                            );
                        }
                    } else {
                        this.setState({
                            receiverAddresses: [],
                            receiverAddress: null,
                            cargoDestinationLat: null,
                            cargoDestinationLong: null,
                            cargoDestination: ""
                        })
                    }
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };
      
    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        let errorInputs = [];
        
        if (this.state.Bastebandy === null || this.state.Bastebandy === "") {
            error.push("انتخاب  بسته‌بندی الزامی میباشد.");
            errorInputs.push("Bastebandy");
        }

        if ((this.state.bastebandyNumber === null || toEnglishNumbers(this.state.bastebandyNumber) === 0 || this.state.bastebandyNumber === "" || this.state.bastebandyNumber === undefined || toEnglishNumbers(this.state.bastebandyNumber) === "0") && this.state.Bastebandy && this.state.Bastebandy.BastebandyID !== 1) {
            error.push('وارد كردن تعداد بسته الزامی میباشد');
            errorInputs.push("bastebandyNumber");
        }

        if (this.state.cargoRange === null) {
            error.push('وارد كردن محدوده رزرو الزامی میباشد');
            errorInputs.push("cargoRange");
        }
        if (this.state.selectedLoaderTypes.length < 1) {
            error.push("انتخاب نوع کشنده الزامی میباشد");
            errorInputs.push("selectedLoaderTypes");
        }
        
        if (!Number(toEnglishNumbers(this.state.freighterNumber))) {
            error.push("وارد كردن تعداد کامیون الزامی میباشد");
            errorInputs.push("freighterNumber");
        }
        //if ((this.state.kalaValue === null || toEnglishNumbers(this.state.kalaValue) === 0)) {
        //    error.push("وارد كردن ارزش محموله الزامی میباشد");
        //    errorInputs.push("kalaValue");
        //}
        if (this.state.Tel === null || this.state.Tel === "" || this.state.Tel === '') {
            error.push("وارد كردن شماره تماس الزامي میباشد");
            errorInputs.push("Tel");
        }
        if ((this.state.kalaWeight === null || toEnglishNumbers(this.state.kalaWeight) === 0)) {
            error.push("وارد كردن وزن محموله الزامی میباشد");
            errorInputs.push("kalaWeight");
        }
        if ((this.state.cargoRent === null || this.state.cargoRent === "" || toEnglishNumbers(this.state.cargoRent) === 0)) {
            error.push("وارد كردن کرایه الزامی میباشد");
            errorInputs.push("cargoRent");
        }

        if (this.state.kala === null || this.state.kala === "") {
            error.push("انتخاب نوع محموله الزامی میباشد.");
            errorInputs.push("kala");
        }
        if (this.state.loadHall === null || this.state.loadHall === "") {
            error.push("انتخاب سالن الزامی میباشد.");
            errorInputs.push("loadHall");
        }
        // if (this.state.sender === "" || this.state.sender === null) {
        //     error.push("انتخاب فرستنده الزامی میباشد");
        //     errorInputs.push("sender");
        // }
        // if (this.state.receiver === "" || this.state.receiver === null) {
        //     error.push("انتخاب گیرنده الزامی میباشد");
        //     errorInputs.push("receiver");
        // }
        // if (this.state.senderAddress === "" || this.state.senderAddress === null) {
        //     error.push("وارد كردن آدرس فرستنده الزامی میباشد");
        //     errorInputs.push("senderAddress");
        // }
        // if (this.state.receiverAddress === "" || this.state.receiverAddress === null) {
        //     error.push("انتخاب آدرس گیرنده الزامی میباشد");
        //     errorInputs.push("receiverAddress");
        // }
        // if (this.state.receiverAddress === this.state.senderAddress) {
        //     error.push("آدرس گیرنده نمی‌تواند با آدرس فرستنده برابر باشد");
        //     errorInputs.push("receiverAddress");
        //     errorInputs.push("senderAddress");
        // }

        if (this.state.cargoSource === null || this.state.cargoSource === "" || this.state.cargoSource === undefined || this.state.cargoDestination === null || this.state.cargoDestination === undefined || this.state.cargoDestination === "") {
            error.push("وارد كردن مبدا و مقصد الزامی میباشد");
            errorInputs.push("cargoSource");
        }
        if (this.state.cargoDistance === null || this.state.cargoDistance === "" || this.state.cargoDistance === undefined || this.state.cargoDuration === null || this.state.cargoDuration === undefined || this.state.cargoDuration === "") {
            error.push("لطفا دوباره مسیریابی کنید");
            errorInputs.push("cargoDuration");
        }

        this.setState({ errors: error, errorInputs: errorInputs });
        if (error.length === 0) {
            this.submitForm();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };
     submitForm = () => {
         let loaderTypeIds = [];

         for (let i = 0; i < this.state.selectedLoaderTypes.length; i++) {
             loaderTypeIds.push(this.state.selectedLoaderTypes[i].id);
         }

         
         const editModel = {

           
             Id: this.state.cargoId,
             SenderCustomerAddressId: this.state.senderAddress ? this.state.senderAddress.id : null,
             ReceiverCustomerAddressId: this.state.receiverAddress ? this.state.receiverAddress.id : null,
             KalaId: this.state.kala.id,
             KalaValue: (this.state.kalaValue !== null && this.state.kalaValue !== undefined && this.state.kalaValue !== "") ? toEnglishNumbers(this.state.kalaValue) : null,
             Tel: (this.state.Tel),
             KalaWeight: toEnglishNumbers(this.state.kalaWeight),
             BastebandyId: this.state.Bastebandy.id,
             BastebandyNumber: toEnglishNumbers(this.state.bastebandyNumber),
             CargoRent: toEnglishNumbers(this.state.cargoRent),
             FreighterNumber: toEnglishNumbers(this.state.freighterNumber),
             CargoSource: this.state.cargoSource,
             CargoDestination: this.state.cargoDestination,
             CargoSourceLat: toEnglishNumbers(this.state.cargoSourceLat),
             CargoSourceLong: toEnglishNumbers(this.state.cargoSourceLong),
             CargoDestinationLat: toEnglishNumbers(this.state.cargoDestinationLat),
             CargoDestinationLong: toEnglishNumbers(this.state.cargoDestinationLong),
             CargoDuration: this.state.cargoDuration,
             CargoDistance: this.state.cargoDistance,
             Description: toEnglishNumbers(this.state.description),
             CargoRange: toEnglishNumbers(this.state.cargoRange),
             TransportationCompanyHallId: this.state.loadHall.id,
             LoaderTypeIds: loaderTypeIds,
             IsLoadHall: true,

          

         };

         this.props.showSpinner(); 
         axios.post('/api/v1/cargos/UpdateCargo', editModel)
             .then((res) => {
                 this.props.hideSpinner();
                 this.props.showAlert(res.data.message, "success");
                 //this.props.history.push('/Loads/Detail/' + this.state.LoadId);
             })
             .catch((error) => {
                 this.props.hideSpinner();
                 this.props.showAlert(showCatchError(error), "error");
                 console.log(error.response);
             });
     }; 
     selectHandleChange = (event, value, name) => {
         if (name === "sender") {

             if (value !== undefined && value !== null) {
                 this.setState({ senderAddress: null },
                     () => this.loadSenderAddresses(value.id, null));
             }
             else {
                 this.setState({
                     senderAddress: null,
                     senderAddresses: [],
                     cargoSource: "",
                     cargoSourceLat: "",
                     cargoSourceLong: "",
                     cargoDistance: "",
                     cargoDuration: "",
                 })
             }

         }
         else if (name === "senderAddress") {
             if (value !== undefined && value !== null) {
                 this.setState({ cargoSource: value.cityName },
                     () => this.getOriginGeocode());
             }
             else {
                 this.setState({

                     cargoDestination: "",
                     cargoDestinationLat: "",
                     cargoDestinationLong: "",
                     cargoDistance: "",
                     cargoDuration: "",
                 })
             }
         }
         else if (name === "receiver") {
             if (value !== undefined && value !== null) {
                 this.setState({ receiverAddress: null },
                     () => this.loadReceiverAddresses(value.id, null));
             }
             else {
                 this.setState({
                     receiverAddress: null,
                     receiverAddresses: [],
                     cargoDestination: "",
                     cargoDestinationLat: "",
                     cargoDestinationLong: "",
                     cargoDistance: "",
                     cargoDuration: "",
                 })
             }
         }
         else if (name === "receiverAddress") {
             if (value !== undefined && value !== null) {
                 this.setState({ cargoDestination: value.cityName },
                     () => this.getDestinationGeocode());
             }
             else {
                 this.setState({

                     cargoDestination: "",
                     cargoDestinationLat: "",
                     cargoDestinationLong: "",
                     cargoDistance: "",
                     cargoDuration: "",
                 })
             }
         }


         if (name === "selectedLoaderTypeCode") {

             if (value !== undefined && value !== null) {
                 this.setState({ selectedLoaderTypes: [] },
                     () => this.getLoaderTypesByCode(value.typeCode));

             }
             else {
                 this.setState({
                     selectedLoaderTypes: [],

                 })
             }

             //this.setState({ selectedLoaderTypes: null }, () => {
             //    if (value && value.typeCode) {
             //        this.getLoaderTypesByCode(value.typeCode);
             //    }
             //});
         }
         this.setState({ [name]: value });
     };
   
    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3> ويرايش اعلام بار</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                


                {/* { <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                                    <div className="w-md-25 w-100 mx-1 d-flex align-items-center">
                                        <Button
                                            className="addCargoSettingButtons m-1"
                                            outline color="primary" size="sm"
                                            aria-controls="sender-menu"
                                            aria-haspopup="true"
                                            aria-expanded={this.state.senderOptionsMenu ? 'true' : undefined}
                                            onClick={(event) => this.OptionsMenuClick(event, 'senderOptionsMenu')}
                                        >
                                            <i className="fa fa-cog" aria-hidden="true" />
                                        </Button>
                                        <Menu
                                            id="sender-menu"
                                            MenuListProps={{ 'aria-labelledby': 'fade-button' }}
                                            anchorEl={this.state.senderOptionsMenu}
                                            open={this.state.senderOptionsMenu}
                                            onClose={() => this.OptionsMenuClose('senderOptionsMenu')}
                                        >
                                            <MenuItem onClick={() => this.openCustomerModal('addCustomerModal', 'senderOptionsMenu')}>ایجاد فرستنده</MenuItem>
                                            {this.state.sender != null ?
                                                <>
                                                    <MenuItem onClick={() => this.openCustomerModal('editCustomerModal', 'senderOptionsMenu')}>ویرایش اطلاعات فرستنده</MenuItem>
                                                    <MenuItem onClick={() => this.openCustomerModal('manageCustomerModal', 'senderOptionsMenu')}>مدیریت آدرس‌های فرستنده</MenuItem>
                                                </>
                                                :
                                                null
                                            }
                                            <MenuItem onClick={() => this.openCustomerModal('manageCustomersModal', 'senderOptionsMenu')}>مدیریت مشتریان</MenuItem>
                                        </Menu>
                                        <FormGroup className="w-100">
                                            <Label>*فرستنده:</Label>
                                            <Autocomplete
                                                clearText={"حذف"}
                                                closeText={"بستن"}
                                                noOptionsText={"در حال دریافت اطلاعات.."}
                                                openText={"باز کردن"}
                                                className="react-select__control"
                                                id="sender"
                                                options={this.state.customer}
                                                getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                value={this.state.sender}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "sender")}
                                                renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                            />
                                        </FormGroup>
                                    </div>

                                    <FormGroup className="w-md-25 w-100 mx-1">
                                        <Label>*آدرس فرستنده:</Label>
                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="senderAddress"
                                            options={this.state.senderAddresses}
                                            getOptionLabel={(option) => option.address + ' (کد پستی: ' + option.postalCode + ')'}
                                            value={this.state.senderAddress}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "senderAddress")}
                                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                        />
                                    </FormGroup>

                                    <div className="w-md-25 w-100 mx-1 d-flex align-items-center">
                                        <Button
                                            className="addCargoSettingButtons m-1"
                                            outline color="primary" size="sm"
                                            aria-controls="sender-menu"
                                            aria-haspopup="true"
                                            aria-expanded={this.state.receiverOptionsMenu ? 'true' : undefined}
                                            onClick={(event) => this.OptionsMenuClick(event, 'receiverOptionsMenu')}
                                        >
                                            <i className="fa fa-cog" aria-hidden="true" />
                                        </Button>
                                        <Menu
                                            id="sender-menu"
                                            MenuListProps={{ 'aria-labelledby': 'fade-button', }}
                                            anchorEl={this.state.receiverOptionsMenu}
                                            open={this.state.receiverOptionsMenu}
                                            onClose={() => this.OptionsMenuClose('receiverOptionsMenu')}
                                        >
                                            <MenuItem onClick={() => this.openCustomerModal('addCustomerModal', 'receiverOptionsMenu')}>ایجاد گیرنده</MenuItem>
                                            {this.state.receiver != null ?
                                                <>
                                                    <MenuItem onClick={() => this.openCustomerModal('editCustomerModal', 'receiverOptionsMenu')}>ویرایش اطلاعات گیرنده</MenuItem>
                                                    <MenuItem onClick={() => this.openCustomerModal('manageCustomerModal', 'receiverOptionsMenu')}>مدیریت آدرس‌های گیرنده</MenuItem>
                                                </>
                                                :
                                                null
                                            }
                                            <MenuItem onClick={() => this.openCustomerModal('manageCustomersModal', 'receiverOptionsMenu')}>مدیریت مشتریان</MenuItem>
                                        </Menu>
                                        <FormGroup className="w-100" >
                                            <Label>*گیرنده:</Label>
                                            <Autocomplete
                                                clearText={"حذف"}
                                                closeText={"بستن"}
                                                noOptionsText={"در حال دریافت اطلاعات.."}
                                                openText={"باز کردن"}
                                                className="react-select__control"
                                                id="receiver"
                                                options={this.state.customer}
                                                getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                value={this.state.receiver}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "receiver")}
                                                renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                            />
                                        </FormGroup>
                                    </div>

                                    <FormGroup className="w-md-25 w-100 mx-1">
                                        <Label>*آدرس گیرنده:</Label>
                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="receiverAddress"
                                            options={this.state.receiverAddresses}
                                            getOptionLabel={(option) => option.address + ' (کد پستی: ' + option.postalCode + ')'}
                                            value={this.state.receiverAddress}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "receiverAddress")}
                                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                        />
                                    </FormGroup>
                                </div>


                            </CardBody>
                        </Card>
                    </Colxx>
                </Row> } */}


                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                                <FormGroup className="w-md-20 w-100 mx-1">
                                                <Label>*انتخاب سالن</Label>

                                                <Autocomplete
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="loadHall"
                                                    options={this.state.LoadHallList}
                                                    getOptionLabel={(option) => option.loadHallName}
                                                    value={this.state.loadHall}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "loadHall")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>* شهر مبدا</Label>
                                        <Input value={this.state.cargoSource} innerRef={this.cargoSource} placeholder=" "
                                            onChange={(e) => this.setState({ cargoSource: e.target.value },
                                                () => { if (this.state.iranmap) this.getCityOrigin() })} />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*شهر مقصد</Label>
                                        <Input value={this.state.cargoDestination} innerRef={this.cargoDestination} placeholder=" "
                                            onChange={(e) => this.setState({ cargoDestination: e.target.value },
                                                () => { if (this.state.iranmap) this.getCityDestination() })} />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*وزن محموله (کیلوگرم)</Label>
                                        <Input value={toCurrency(this.state.kalaWeight)}
                                            onChange={(e) => this.setState({ kalaWeight: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*صافی کرایه (تومان)</Label>
                                        <Input value={toCurrency(this.state.cargoRent)} maxLength={14}
                                            onChange={(e) => this.setState({ cargoRent: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>شماره تماس جهت هماهنگی</Label>
                                        <Input value={(this.state.Tel)}
                                            onChange={(e) => this.setState({ Tel: e.target.value  })} />
                                    </FormGroup>
                                </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                                    <FormGroup className="w-md-30 w-100 px-1">
                                        <Label>*بارگیر:</Label>

                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="selectedLoaderTypeCode"
                                            options={this.state.loaderTypeCodes}
                                            getOptionLabel={(option) => option.loaderTypeName}
                                            value={this.state.selectedLoaderTypeCode}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "selectedLoaderTypeCode")}
                                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                        />
                                    </FormGroup>
                                    <FormGroup className="w-md-30 w-100 px-1">
                                        <Label>*بارگیر های مورد نیاز :</Label>
                                        <Autocomplete
                                            multiple
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="selectedLoaderTypes"
                                            options={this.state.loaderTypes}
                                            groupBy={(option) => option.loaderTypeName}
                                            getOptionLabel={(option) => option.loaderTypeName + " " + option.loaderTypeDesc}
                                            value={this.state.selectedLoaderTypes}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "selectedLoaderTypes")}
                                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                        />
                                    </FormGroup>
                                </div>
                                    <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*نوع محموله:</Label>
                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="kala"
                                            groupBy={(option) => option.kalaDesc}
                                            options={this.state.kalas}
                                            getOptionLabel={(option) => option.kalaDesc+" شرح:"+option.logesticDesc}
                                            value={this.state.kala}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "kala")}
                                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                        />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*بسته‌بندی:</Label>
                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="Bastebandy"
                                            options={this.state.Bastebandys}
                                            groupBy={(option) => option.name}
                                            getOptionLabel={(option) => option.name}
                                            value={this.state.Bastebandy}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "Bastebandy")}
                                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                        />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*تعداد کامیون</Label>
                                        <Input value={this.state.freighterNumber}
                                            onChange={(e) => this.setState({ freighterNumber: e.target.value.replace(/[^0-9۰-۹]/g, "").length > 3 ? 1 : e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                    </FormGroup>
                                    <FormGroup className="w-md-60 w-100 px-1">
                                        <Label>شرح بار</Label>
                                        <Input value={this.state.description} type="textarea"
                                            onChange={(e) => this.setState({ description: e.target.value })} />
                                    </FormGroup>
                                </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                {this.state.errors.length === 0 ?
                                    null
                                    :
                                    <div>
                                        {(this.state.errors.map((error, i) => {
                                            return (
                                                <Alert color="danger" key={i}>{error}</Alert>
                                            )
                                        }))}
                                    </div>
                                }


                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center mt-4">
                                    <Button outline color="primary" className="mx-3 my-md-0 my-1"
                                        onClick={() => this.props.showSweetAlert("", "آیا از صحت اطلاعات واردشده اطمینان دارید؟", "warning", this.validateInputData)}>
                                        ويرايش
                                    </Button>

                                  

                                    <Link to={"/"} type="button">
                                        <Button outline color="warning" className="mx-3 my-md-0 my-1">
                                            صفحه اصلي
                                        </Button>
                                    </Link>
                                </div>

                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
                <Row className="mb-3">
                    <Colxx xxs="12"  >
                        <Card >
                            <CardBody className="d-flex flex-column">
                            <Colxx xxs="12">
                                     <h3> اطلاعات تکمیلی </h3>
                                    <Separator className="mb-5" />
                                 </Colxx>
                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                                <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>تعداد بسته</Label>
                                        <Input value={this.state.bastebandyNumber} readOnly
                                            onChange={(e) => this.setState({ bastebandyNumber: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>محدوده رزرو</Label>
                                        <Input value={this.state.cargoRange} readOnly
                                            onChange={(e) => this.setState({ cargoRange: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>مدت زمان</Label>
                                        <Input value={this.state.cargoDuration} readOnly />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>فاصله</Label>
                                        <Input value={this.state.cargoDistance} readOnly />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 mx-1">
                                        <Label>عرض جغرافیایی مبدا</Label>
                                        <Input value={this.state.cargoSourceLat} placeholder="مبدا انتخاب نشده‌است" readOnly />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 mx-1">
                                        <Label>طول جغرافیایی مبدا</Label>
                                        <Input value={this.state.cargoSourceLong} placeholder="مبدا انتخاب نشده‌است" readOnly />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 mx-1">
                                        <Label>عرض جغرافیایی مقصد</Label>
                                        <Input value={this.state.cargoDestinationLat} placeholder="مقصد انتخاب نشده‌است" readOnly />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 mx-1">
                                        <Label>طول جغرافیایی مقصد</Label>
                                        <Input value={this.state.cargoDestinationLong} placeholder="مقصد انتخاب نشده‌است" readOnly />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>ارزش محموله</Label>
                                        <Input value={toCurrency(this.state.kalaValue)}
                                            onChange={(e) => this.setState({ kalaValue: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                    </FormGroup>
                                </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
                 

                <Modal isOpen={this.state.addCustomerModal} size="xlg" toggle={() => this.closeModal("addCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("addCustomerModal")}>
                        افزودن مشتری جدید
                    </ModalHeader>
                    <ModalBody>
                        <AddCustomerModal
                            provinces={this.state.provinces}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("addCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.editCustomerModal} size="xlg" toggle={() => this.closeModal("editCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("editCustomerModal")}>
                        ویرایش مشتری
                    </ModalHeader>
                    <ModalBody>
                        <EditCustomer
                            selectedCustomerToEdit={this.state.currentCustomer}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("editCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.manageCustomersModal} size="xlg" toggle={() => this.closeModal("manageCustomersModal")}>
                    <ModalHeader toggle={() => this.closeModal("manageCustomersModal")}>
                        مدیریت مشتریان
                    </ModalHeader>
                    <ModalBody>
                        <Customer
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("manageCustomersModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>


               
            </>
        );
    }
}

export default EditCargo;